import { render } from "./EventCard.vue?vue&type=template&id=fbc7a566&scoped=true"
import script from "./EventCard.vue?vue&type=script&lang=js"
export * from "./EventCard.vue?vue&type=script&lang=js"

import "./EventCard.vue?vue&type=style&index=0&id=fbc7a566&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-fbc7a566"

export default script